import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TypeMerchantUserEnum } from 'app/models';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { AppDataService, MerchantUserService } from 'app/services';
import { Utils } from 'app/utils';
import { AppComponent } from 'app/app.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'partner-employees',
    templateUrl: './partner-employees.component.html',
    styleUrls: ['./partner-employees.component.scss',
        '../../../../../styles/style-layout.scss']
})
export class PartnerEmployeesComponent implements OnInit, OnChanges {
    constructor(
        private messageService: MessageService, private appData: AppDataService,
        private merchantUserService: MerchantUserService, public app: AppComponent) {
        this.handleEmployeeDetailsPopupHide = this.handleEmployeeDetailsPopupHide.bind(this);
        this.handleDeleteEmployeeHide = this.handleDeleteEmployeeHide.bind(this);
        this.handleSuspendEmployeeHide = this.handleSuspendEmployeeHide.bind(this);
        this.handleCreatePopupHide = this.handleCreatePopupHide.bind(this);
    }

    @Input()
    public menuPermissionActive!: string;

    @Input()
    public typeMerchantUser: TypeMerchantUserEnum = TypeMerchantUserEnum.StoreEmployees;

    ngOnInit(): void {
        this.getMerchantEmployees(0);
    }

    ngOnChanges(): void {
        this.getMerchantEmployees(0);
    }

    public merchantId: string = this.appData.authData.MerchantId;
    public typeCreatedEmployee: TypeMerchantUserEnum = TypeMerchantUserEnum.StoreEmployees;
    public showCreateEmployee: boolean = false;

    public typeMerchantUserEnum = TypeMerchantUserEnum;

    public loading: boolean = false;
    public showEmployeeDetails: boolean = false;
    public merchantUserId: number = 0;
    public showMerchantEmployeeDetailSideBar: boolean = false;

    public showDeleteEmployee: boolean = false;
    public showSuspendEmployee: boolean = false;

    public filter: {
        searchName: string;
        startDateJoin: Date | undefined;
        endDateJoin: Date | undefined;
    } = { searchName: '', startDateJoin: undefined, endDateJoin: undefined };

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    private searchTimer: number = 0;

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getMerchantEmployees(skip);
    }

    public merchantUsers: Array<any> = [];
    public selectedUsers: any;
    public selectedUser: any = {};
    public showEditFields: boolean = false;
    public cols: any[] = [
        { field: 'UserId', header: 'Employee ID', width: '20%' },
        { field: 'UserName', header: 'Name', width: '20%' },
        { field: 'RoleName', header: 'Role', width: '20%' },
        { field: 'CreatedAt', header: 'Created', width: '20%' },
        { field: 'StoreName', header: 'Location', width: '20%' },
        { field: 'StatusStr', header: 'Status', width: '20%' }
    ];

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getMerchantEmployees(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public getMerchantEmployees(skip: number) {
        const dto = {
            MerchantId: this.appData.authData.MerchantId,
            GetAdmins: this.typeMerchantUser === TypeMerchantUserEnum.WebAdmins,
            Skip: skip,
            SearchName: this.filter.searchName,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffSet: Utils.getTimezoneOffset()
        };

        this.merchantUserService.getMerchantUsers(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.merchantUsers = data.Items.map((x: any) => {
                    x.CreatedAt = Utils.utcToLocaleDateString(x.CreatedAt) + ' ' + Utils.utcToLocaleTimeString(x.CreatedAt);
                    x.BirthdayStr = Utils.utcToLocaleDateString(x.Birthday);
                    x.Birthday = new Date(x.Birthday);
                    x.SuspendedUntil = Utils.utcToLocaleDateString(x.SuspendedUntil) + ' ' + Utils.utcToLocaleTimeString(x.SuspendedUntil);
                    return x;
                });;

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
    public handleEmployeeDetailsPopupHide() {
        this.showEmployeeDetails = false;
        this.getMerchantEmployees(0);
    }

    public handleDeleteEmployeeHide() {
        this.showDeleteEmployee = false;
        this.getMerchantEmployees(0);
    }

    public handleSuspendEmployeeHide() {
        this.showSuspendEmployee = false;
        this.getMerchantEmployees(0);
    }

    public openMerchantEmployeeDetailSideBar(merchantUser: any) {
        this.selectedUser = merchantUser;
        this.showEmployeeDetails = true;
    }

    public handleShowEmployeeDetails() {
        this.showEmployeeDetails = true;
        this.showEditFields = true;
    }

    public showDeleteEmployeeDialog(user: any) {
        this.selectedUser = user;
        this.showDeleteEmployee = true;
    }

    public showSuspendEmployeeDialog(user: any) {
        this.selectedUser = user;
        this.showSuspendEmployee = true;
    }

    public handleShowCreateEmployee(tab: TypeMerchantUserEnum) {
        this.typeCreatedEmployee = tab;
        this.showCreateEmployee = true;
        this.showEditFields = true;
    }
    public handleCreatePopupHide() {
        this.showCreateEmployee = false;
        this.getMerchantEmployees(0);
    }
}
